<template>
  <v-card-text>
    <validation-observer ref="form" v-slot="{ invalid }">
      <v-row dense>
        <v-col cols="12" sm="6">
          <case-note-subject-select
            :noteSubject="noteSubject"
            @setNoteSubject="noteSubject = $event"
          ></case-note-subject-select>
        </v-col>
        <v-col cols="12" sm="3">
          <case-note-tags-select
            :tags="noteTags"
            @setNoteTags="noteTags = $event"
          ></case-note-tags-select>
        </v-col>
      </v-row>
      <v-row dense class="mt-0">
        <v-col cols="11" sm="9">
          <form-field
            :field="textEditor"
            @fieldChange="newNoteText = $event"
            :validations="{ required: true }"
          ></form-field>
        </v-col>
        <v-col
          cols="12"
          sm="1"
          v-if="!isProvider"
          class="d-flex align-start justify-start"
        >
          <v-checkbox v-model="isInternal">
            <template v-slot:label>
              <span style="font-size: 10px">Internal</span>
            </template></v-checkbox
          >
        </v-col>
        <v-col cols="12" sm="2" class="d-flex align-start justify-start">
          <v-btn
            text
            color="primary"
            :dark="!invalid && !loading"
            :disabled="invalid || loading"
            :loading="loading"
            @click="saveNote"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </validation-observer>

    <case-notes-table
      :notes="filteredNotes"
      :noEdit="isProvider"
    ></case-notes-table>
  </v-card-text>
</template>
<script>
import CaseNotesTable from "./case-notes-table.vue";
import FormField from "../../../objs/Shared/FormField";
import CaseNoteSubjectSelect from "./case-note-subject-select.vue";
import CaseNoteTagsSelect from "./case-note-tags-select.vue";
export default {
  components: {
    CaseNotesTable,
    CaseNoteSubjectSelect,
    CaseNoteTagsSelect,
  },
  data() {
    return {
      loading: false,
      newNoteText: "",
      isInternal: true,
      noteSubject: "",
      noteTags: [],
    };
  },
  computed: {
    isProvider() {
      return this.$store.getters["securityModule/isProvider"];
    },
    client() {
      return this.$store.state.clientModule.selectedClient;
    },
    filteredNotes() {
      let filteredNotes = this.client?.caseNotes;
      if (this.isProvider) {
        filteredNotes = filteredNotes.filter((item) => !item.isInternal);
      }
      if (this.noteSubject) {
        filteredNotes = filteredNotes.filter((item) => {
          if (this.isCustomSubject) {
            return item.customSubject == this.noteSubject;
          } else {
            return item.subjectId == this.noteSubject?.subjectId;
          }
        });
      }
      if (this.noteTags.length > 0) {
        var ids = this.noteTags.map((x) => x.tagId);
        filteredNotes = filteredNotes.filter((item) => {
          return item.tags.some((x) => ids.includes(x.tagId));
        });
      }
      return filteredNotes || [];
    },
    textEditor() {
      return new FormField({
        value: this.newNoteText,
        label: "Enter new note",
        icon: "mdi-comment",
        componentName: "text-area",
      });
    },
    isCustomSubject() {
      return typeof this.noteSubject === "string";
    },
  },
  methods: {
    async saveNote() {
      this.loading = true;
      let success = await this.$store.dispatch("clientModule/saveCaseNote", {
        clientId: this.client?.clientId,
        noteText: this.newNoteText,
        isInternal: this.isInternal,
        ...(!this.isCustomSubject && {
          subjectId: this.noteSubject?.subjectId,
        }),
        ...(this.isCustomSubject && {
          customSubject: this.noteSubject,
        }),
        tags: this.noteTags,
      });
      this.loading = false;

      if (!success) {
        this.$store.commit("uxModule/setSnackbarMsg", "Error saving note");
        this.$store.commit("uxModule/setShowSnackbar", true);
      }

      this.clear();
    },
    clear() {
      this.$refs.form.reset();
      this.newNoteText = "";
      this.isInternal = true;
    },
  },
};
</script>
